import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlogRollComponent, FiveReasonsToComponent, SuperSizedShippingComponent, FiveTrendsShapingComponent, GlassHalfFullComponent, WalmartAmazonTakeComponent, AnalyticsAnswerYourBusinessQuestions, SampleNewsComponent } from './';

import { AppContext, SeoService } from './../shared';
import { SharedModule } from './../shared/shared.module';
import { BlogRoutingModule } from './blog-routing.module';

@NgModule({
  imports: [CommonModule, BlogRoutingModule, SharedModule],
  declarations: [BlogRollComponent, FiveReasonsToComponent, SuperSizedShippingComponent, FiveTrendsShapingComponent, GlassHalfFullComponent, WalmartAmazonTakeComponent, AnalyticsAnswerYourBusinessQuestions, SampleNewsComponent],
  exports: [BlogRollComponent, FiveReasonsToComponent, FiveTrendsShapingComponent, SuperSizedShippingComponent, GlassHalfFullComponent, WalmartAmazonTakeComponent, AnalyticsAnswerYourBusinessQuestions, SampleNewsComponent],
  providers: [AppContext, SeoService]
})

export class BlogModule { }



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/blog/blog.module.ts